"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * @Author: huangzq
 * @Date: 2019-10-11 15:32:19
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-09-23 15:28:47
 * @Desc: 微信授权方法
 */
var multi_qm_parse_1 = __importDefault(require("./multi-qm-parse"));
var url_encode_1 = __importDefault(require("./url-encode"));
// 跳转到后端A接口去，执行真正的授权流程
var toWxAuth = function (config) {
    // * 现目前我们的授权方式是：前端->后端A接口->重定向微信授权网址->回调到后端B接口->再重定向前端
    if (config.urlParams.redirect === '') {
        var _a = window.location, origin_1 = _a.origin, pathname = _a.pathname, hash = _a.hash;
        var hashArr = hash.split('?');
        var urlParamsObj_1 = (0, multi_qm_parse_1.default)(hash);
        ['code', 'appid', 'appId', 'state', 'openid'].forEach(function (key) {
            delete urlParamsObj_1[key];
        });
        // 下方法出现分享参数在授权参数后时被截取
        // * 将search去掉多余的code、appid、state、openid等微信传递过来的参数
        // const _search = hash
        //   .split('&code=')[0]
        //   .split('&appid=')[0]
        //   .split('&state=')[0]
        //   .split('&openid=')[0]
        var concatUrl = (0, url_encode_1.default)(urlParamsObj_1, false, '').substr(1);
        config.urlParams.redirect = "".concat(origin_1).concat(pathname).concat(hashArr[0], "?").concat(concatUrl);
    }
    if (config.needBase64) {
        // base64转码：因为前端网址会存在多个参数，所以必须转码后，传给后端，后端才能正确的拿到前端传递的网址，不然会截断部分参数
        config.urlParams.redirect = encodeURIComponent(config.urlParams.redirect);
    }
    // 在config.url的基础上，拼接所需参数，生成最终后端的网址
    var finalHref = "".concat(config.url, "?").concat((0, url_encode_1.default)(config.urlParams, false, ''));
    window.location.replace(finalHref);
};
exports.default = (function (_config) {
    return new Promise(function (resolve, reject) {
        // 默认配置参数
        var defaultConfig = {
            /**
             * close
             * 描述：是否关闭授权
             * 必填：非必填
             * 类型：String|Boolean
             * 默认值：'baseOnWx'，表示基于【是否为微信浏览器】，自动开关授权
             * 可选值：
             *  false：表示一直开启授权，不论什么浏览器
             *  true：表示一直关闭授权，不论什么浏览器
             */
            close: 'baseOnWx',
            /**
             * url
             * 描述：后端【微信 公众号授权】网址
             * 必填：必填
             * 类型：String
             * 默认值：''
             */
            // https://mk-wx-dev.dustess.com/wxopen/v1/wxpublic/auth
            url: '',
            /**
             * urlParams
             * 描述：跳转后端【微信 公众号授权】网址，所带的地址参数
             * 必填：非必填
             * 类型：Object
             * 默认值：如下
             */
            urlParams: __assign({ 
                /**
                 * redirect
                 * 描述：传给后端的，用于最后的重定向
                 * 必填：非必填
                 * 类型：String
                 * 默认值：空，表明使用当前页面的网址
                 */
                redirect: '', 
                /**
                 * scope
                 * 描述：微信授权类型：snsapi_base|snsapi_userinfo
                 * 必填：非必填
                 * 类型：String
                 * 默认值：'snsapi_userinfo'
                 */
                scope: 'snsapi_userinfo' }, _config.urlParams),
            /**
             * needBase64
             * 描述：是否需要base64转码前端网址
             * 必填：非必填
             * 类型：Boolean
             * 默认值：true
             */
            needBase64: true,
            /**
             * tokenKey
             * 描述：往sessionStorage里面存token时的key值
             * 必填：非必填，但不可为空
             * 类型：String
             * 默认值：'token'
             */
            tokenKey: 'token'
        };
        // 删除传进来的配置里面的urlParams字段，因为在上边已经将它解构到defaultConfig.urlParams里面了
        delete _config.urlParams;
        // 默认配置与传进来的配置组合成最新的配置
        var config = __assign(__assign({}, defaultConfig), _config);
        // 是否使用微信授权
        var needUseWxAuth = true;
        console.log('我执行了');
        if (config.close === true) {
            // 当close为true，表示一直关闭授权，不论什么浏览器
            needUseWxAuth = false;
            console.log('你已手动【关闭】微信授权，不论什么浏览器：授权函数将自动resolve，请走后续初始化等其他流程');
            // 不使用微信授权，就直接resolve，并且返回{tokenExist:true}，目的使外面的流程跑通
            resolve({ tokenExist: true, needUseWxAuth: needUseWxAuth });
        }
        else if (config.close === false) {
            // 当close为false，表示一直开启授权，不论什么浏览器
            needUseWxAuth = true;
            console.log('你已手动【开启】微信授权，不论什么浏览器');
        }
        else {
            // 表明既不为true，也不为false，则通过【是否为微信浏览器】条件，自动开关授权
            // 是否为微信浏览器
            var isWx = /micromessenger/i.test(navigator.userAgent);
            needUseWxAuth = isWx;
            if (!isWx) {
                console.log('你当前不是微信浏览器，已【自动关闭】微信授权：授权函数将自动resolve，请走后续初始化等其他流程');
                // 不使用微信授权，就直接resolve，并且返回{tokenExist:true}，目的使外面的流程跑通
                resolve({ tokenExist: true, isWx: isWx });
            }
        }
        if (needUseWxAuth) {
            try {
                if (!config.url) {
                    throw new Error('config.url：后端【微信 公众号授权】网址必填');
                }
                console.log('开始执行微信授权方法');
                // token是否存在
                var isToken = !!JSON.parse(sessionStorage.getItem(config.tokenKey) || 'null');
                if (isToken) {
                    // token为true，则表明：【已经登录过了】，直接执行初始化页面
                    console.log('【token已存在，用户已授过权】：授权函数将自动resolve，请走后续初始化等其他流程');
                    resolve({ tokenExist: isToken, needUseWxAuth: needUseWxAuth });
                }
                else {
                    // 获取地址参数的对象
                    var urlParamsObj = (0, multi_qm_parse_1.default)(window.location.hash);
                    // 获取地址参数上的code值
                    var code = urlParamsObj.code;
                    if (code) {
                        // code存在，表明已经从微信授权网页回来了，网址上将会带有相关的appid等参数
                        // 将网址上的微信授权相关参数存在sessionStorage里面去
                        sessionStorage.setItem('authCallbackUrlParams', JSON.stringify(urlParamsObj));
                        var needPushState = false;
                        if (needPushState) {
                            var origin_2 = location.origin, pathname = location.pathname, hash = location.hash;
                            // * 将search去掉多余的code、appid、state等微信传递过来的参数
                            var _search = hash
                                .split('&appid=')[0]
                                .split('&appId=')[0]
                                .split('&state=')[0]
                                .split('&code=')[0];
                            var _href = pathname + _search;
                            // 该方法必须存在，只有这样处理了，使用系统自带的返回，才会触发window.addEventListener('popstate')事件，最终才能通过微信的jsdk去关闭网页，到达正常的退出效果
                            /**
                             * !已废弃该说法：延时目的为解决iOS二维码无法识别bug，极限延时为13，原因为微信载入图片资源的时候，识别二维码是根据当前url的路径载入图片资源进行识别的。
                             * 所以需要等待图片资源载入完成后去单方面修改url
                             */
                            window.history.pushState({
                                status: 0
                            }, '', origin_2 + _href);
                        }
                        console.log('【微信授权完成】：1、请查看sessionStorage里面的授权网址的回调参数authCallbackUrlParams');
                        console.log('【微信授权完成】：2、授权函数将resolve，请走后续初始化等其他流程');
                        var isWx = /micromessenger/i.test(navigator.userAgent);
                        resolve({
                            codeExist: true,
                            authCallbackUrlParams: urlParamsObj,
                            isWx: isWx,
                            tokenExist: false
                        });
                        return;
                    }
                    else
                        toWxAuth(config);
                    // }
                }
            }
            catch (error) {
                reject(error);
            }
        }
    });
});
//# sourceMappingURL=data:application/json;base64,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